import type { ButtonHTMLAttributes } from 'react';

type Variant = 'primary' | 'secondary' | 'ghost' | 'danger';

const variants: Record<Variant, string> = {
  primary: 'bg-clinical-primary text-white shadow-sm hover:bg-clinical-primary-hover',
  secondary: 'border border-clinical-line bg-clinical-card text-clinical-ink hover:bg-clinical-surface',
  ghost: 'text-clinical-primary hover:bg-clinical-primary/10',
  danger: 'bg-clinical-danger text-white shadow-sm hover:opacity-90'
};

export function Button({ className = '', variant = 'primary', ...props }: ButtonHTMLAttributes<HTMLButtonElement> & { variant?: Variant }) {
  return (
    <button
      className={`focus-ring inline-flex min-h-11 items-center justify-center gap-2 rounded-lg px-4 py-2.5 text-sm font-semibold transition disabled:cursor-not-allowed disabled:opacity-60 ${variants[variant]} ${className}`}
      {...props}
    />
  );
}
